import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MonitorWeightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"monitor_weight"}/>
}
